const data = [ 
    {
        "id": 1,
        "image":"assets/images/maryjane.jpg",
        "alt":"Mary Jane's Market",
        "name":"Mary Jane's Market",
        "text":"My final project for Rutgers Full Stack Coding Bootcamp. With legalization being passed this November we thought it would be witty to set up an e-commerce and educational dispensary app as many New Jerseyans will be seeing dispensaries popping up around the state. This one was created utilizing the 'MERN' stack in which I handled all of the routes to and from the database starting with the user adding products to their cart, all of the logic that separately added products and their totals, as well as deleting items from the cart.",
        "appUrl": "https://maryjanesmarket.herokuapp.com/",
        "githubUrl": "https://github.com/BrianGearty/Mary-Janes-Market"
    },
    {
    "id": 2,
    "image":"assets/images/lemarchefrancais.jpg",
    "alt":"French Market",
    "name":"Le Marché Français",
    "text":"Developed an app that allows a user to virtually shop a fresh marketplace from the comfort of their home and check out to pick up their order. The only thing I didnt handle was a little bit of the styling. For this project I used HTML, CSS, Handlebars, Javascript, Jquery, and Ajax.",
    "appUrl": "https://lemarchefrancais.herokuapp.com/",
    "githubUrl": "https://github.com/BrianGearty/Project_2"
},
{
    "id": 3,
    "image":"assets/images/goldenchild.jpg" ,
    "alt":"Golden Child Meal Planner",
    "name":"Golden Child Meal Planner",
    "text":"This was the first group project I worked on. We decided on creating a meal planner for people with busy schedules to help plan their meals and grocery shopping weeks or even months ahead of time. We used HTML, CSS, JavaScript, Jquery, Ajax and Third Party API's. Try it out here!",
    "appUrl": "https://briangearty.github.io/Golden-Child-Meal-Planner/",
    "githubUrl": "https://github.com/BrianGearty/Golden-Child-Meal-Planner"
},
    {
    "id": 4,
    "image":"assets/images/musicquiz.jpg",
    "alt":"Music Quiz",
    "name":"Music Quiz",
    "text":"This is a simple quiz app that begins with the click of a start button as well as a timer. This one was a lot of fun! Take the quiz here! ",
    "appUrl": "https://briangearty.github.io/QuizHomework/",
    "githubUrl": "https://github.com/BrianGearty/QuizHomework"
},
    {
    "id": 5,
    "image":"assets/images/weather.jpg",
    "alt":"Weather Dashboard",
    "name":"Weather Dashboard",
    "text":"This is a simple weather application that gets the current weather for a selected city as well as the 5 day forecast. You can type any city into the search bar and it will show the weather for that city.",
    "appUrl": "https://briangearty.github.io/Weather/",
    "githubUrl": "https://github.com/BrianGearty/Weather"
}

]

export default data;